<template>
    <ul v-if="items" role="menu">
        <template v-for="(item, i) of items">
            <li v-if="visible(item) && !item.separator" :key="item.label || i" :class="[{ 'layout-root-menuitem': root, 'active-menuitem': activeIndex === i && !item.disabled }]" role="none">
                
                <div class="layout-menu-color layout-menuitem-root-text" style="text-transform: uppercase" v-if="root">{{ item.label }}</div>
                
                <!--
                    <router-link
                    v-if="item.to"
                    :to="item.to"
                    :style="item.style"
                    :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
                    :target="item.target"
                    exact
                    active-class="active-route"
                    @click="onMenuItemClick($event, item, i)"
                    @mouseenter="onMenuItemMouseEnter(i)"
                    role="menuitem"
                    v-ripple
                    >
                        
                        <span class="layout-menu-color layout-menuitem-text">{{ item.label }}</span>
                        <em v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler layout-menu-color"></em>
                    </router-link>
                -->
                
                <a
                    v-if="!item.to"
                    :href="item.url || '#'"
                    :style="{'text-decoration':'none'}"                    
                    :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
                    :target="item.target"
                    @click="onMenuItemClick($event, item, i)"
                    @mouseenter="onMenuItemMouseEnter(i)"
                    v-ripple>
                    <span style="display: flex; align-items:center" :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]">
                        <em v-if="item.iconData?.isDisplable" style="font-size: 1.6rem;" class="p-mr-3" :class="['layout-menu-color layout-menuitem-icon', item.icon]"></em>
                        <span class="layout-menu-color layout-menuitem-text" :style="{ 'font-size' : item.items ? '1.0rem':'1.1rem'}">{{ item.label }}</span>
                        <em v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler layout-menu-color"></em>
                    </span>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">{{ item.label }}</div>
                </div>
                <transition name="layout-menu">
                    <appsubmenu
                        v-show="item.items && (root && (!isSlim() || (isSlim() && (mobileMenuActive || activeIndex !== null))) ? true : activeIndex === i)"
                        :items="visible(item) && item.items"
                        :menuActive="menuActive"
                        :layoutMode="layoutMode"
                        :parentMenuItemActive="activeIndex === i"
                        @menuitem-click="$emit('menuitem-click', $event)"
                    ></appsubmenu>
                </transition>
            </li>
        </template>
    </ul>
</template>
<style scoped lang="scss">
.layout-menu-color {
    color: var(--surface-900) !important;
    //color: var(--blue-700) !important;
}

.refined-menu-item {
    display: flex;
    align-items: center;
}

@media screen and (max-width: 896px) {
    .refined-menu-item {
        display: none;
    }
}

</style>
<script>
import EventBus from './event-bus';

export default {
    name: 'appsubmenu',
    emits: ['root-menuitem-click', 'menuitem-click'],
    props: {
        items: Array,
        layoutMode: String,
        menuActive: Boolean,
        mobileMenuActive: Boolean,
        root: {
            type: Boolean,
            default: false,
        },
        parentMenuItemActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeIndex: null,
        };
    },
    mounted() {
        EventBus.on('reset-active-index', () => {
            if (this.layoutMode === 'horizontal' || this.layoutMode === 'slim') {
                this.activeIndex = null;
            }
        });
    },
    methods: {
        onMenuItemClick(event, item, index) {
            if (item.disabled) {
                event.preventDefault();
                return;
            }

            //execute command
            if (item.command) {
                item.command({ originalEvent: event, item: item });
                event.preventDefault();
            }

            if (item.items) {
                event.preventDefault();
            }

            if (this.root) {
                this.$emit('root-menuitem-click', {
                    originalEvent: event,
                });
            }

            if (item.items) {
                this.activeIndex = index === this.activeIndex ? null : index;
            } else {
                if (this.layoutMode !== 'static') {
                    const ink = this.getInk(event.currentTarget);
                    if (ink) {
                        this.removeClass(ink, 'p-ink-active');
                    }
                }
            }

            this.$emit('menuitem-click', {
                originalEvent: event,
                item: item,
            });
        },
        isMobile() {
            return window.innerWidth <= 1025;
        },
        onMenuItemMouseEnter(index) {
            if (this.root && this.menuActive && (this.layoutMode === 'horizontal' || this.layoutMode === 'slim') && !this.isMobile()) {
                this.activeIndex = index;
            }
        },
        visible(item) {
            return typeof item.visible === 'function' ? item.visible() : item.visible !== false;
        },
        isSlim() {
            return this.layoutMode === 'slim';
        },
        isHorizontal() {
            return this.layoutMode === 'horizontal';
        },
        getInk(el) {
            for (let i = 0; i < el.children.length; i++) {
                if (typeof el.children[i].className === 'string' && el.children[i].className.indexOf('p-ink') !== -1) {
                    return el.children[i];
                }
            }
            return null;
        },
        removeClass(element, className) {
            if (element.classList) element.classList.remove(className);
            else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
    },
};
</script>

<style scoped></style>
